module.exports = __webpack_public_path__ + "static/media/example05-02.1a4d284b.svg";